import React, { Component } from "react";
import Card from "../../component/Card";
import FilterForm from "./FilterForm";
import Print from "view/laporan/Print";
import { getSexString, getVisitTypeName } from "../../../helper/helper";
import Export from "view/laporan/Export";
import ReactToPrint from "react-to-print";
import Table from "../../component/Table";
import withContext from "../../hoc/withContext";
import { KunjunganPasienContext } from "view/laporan/Context";
import { InlineLoading } from "../../component/Loading";
import apiService from "apiService";
import data from "view/Grafik/villageBorder";

class ReportIlp extends Component {
  printComponentRef = React.createRef();

  printedBody = document.body.innerHTML;

  onChangereason = async (data, id) => {
    const res = await apiService.post("/report/overdue/create", {
      visit_id: data.id,
      reason_id: id,
    });
    console.log(res);
  };

  generateHasil = (screening) => {
    let view = [];
    screening.map((a) => {
      let dt = a.result;
      let res = [];
      Object.keys(dt).map((key) => {
        res = [];
        dt[key].map((b) => {
          if (b.keterangan != "") {
            res.push(
              <p>
                Usia: {b.umur ? b.umur : key} , Hasil: {b.keterangan}
              </p>
            );
          }
        });
      });

      view.push(
        <div>
          <h4>{a.screening_name}</h4>
          {res}
        </div>
      );
    });
    return view;
  };
  generateAns = (data, header) => {
    let ans = [];
    header.map((a, k) => ans.push(data["k" + (k + 1)]));
    return ans;
  };

  generateExcell = (data, header) => {
    let ans = [];
    header.map((a, k) => (ans[a] = data["k" + (k + 1)]));
    ans = Object.assign({}, ans);
    return ans;
  };
  render() {
    const { store } = this.context;
    let header = store.dataKunjungan?.data?.header_table ?? [];
    // console.log(store);
    // const {report} = this.props.data;
    return (
      <div className="container-fluid my-3">
        <Card>
          <Card.Body>
            <FilterForm />
          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <div className="d-flex justify-content-left my-2 row">
              <Export
                csvData={store.dataKunjungan?.data?.data_table}
                disabled={
                  !store.dataKunjungan?.data?.data_table || store.onLoad
                    ? true
                    : false
                }
                fileName={"laporan_ilp"}
                columnMapper={(data) => {
                  return {
                    nama: data.names,
                    ...this.generateExcell(data, header),
                  };
                }}
              />
              <ReactToPrint
                trigger={() => (
                  <button
                    disabled={
                      !store.dataKunjungan?.data || store.onLoad ? true : false
                    }
                    className="btn btn-primary"
                  >
                    Cetak
                  </button>
                )}
                content={() => this.printComponentRef.current}
                pageStyle={{ overflow: "visible" }}
                copyStyles={true}
              />
              <div className="my-auto col-md-7">
                <InlineLoading
                  isLoading={store.onLoad}
                  textInfo="Mengunduh Dokumen..."
                />
              </div>
              <div className="col-md-2">
                <div className="dropdown">
                  <a
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <button className="btn btn-primary">
                      {" "}
                      <i className="fas fa-ellipsis-v " /> Aksi{" "}
                    </button>
                  </a>
                  <div
                    className="dropdown-menu dropdown-menu-right dropdown-menu-arrow"
                    x-placement="bottom-end"
                    style={{
                      position: "relative",
                      willChange: "transform",
                      top: 0,
                      left: 0,
                      transform: "translate3d(31px, 32px, 0px)",
                    }}
                  >
                    <a className="dropdown-item">
                      <button className="btn btn-secondary">
                        Export Asik PTM (Gangguan Kardiovaskuler, Metabolik dan
                        Kanker)
                      </button>
                    </a>
                    <a className="dropdown-item">
                      <button className="btn btn-secondary">
                        Gangguan Indra
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <Table
              isLoading={store.onLoad}
              isBordered={true}
              headers={["No", "Nama", ...header]}
              columnMapper={(data) => [
                data.names,
                ...this.generateAns(data, header),
              ]}
              data={store.dataKunjungan?.data?.data_table}
            />
          </Card.Body>
        </Card>
        <div className="d-none">
          <Print
            ref={this.printComponentRef}
            datas={store.dataKunjungan?.data?.data_table}
            headers={["No", "Nama", ...header]}
            columnMapper={(data) => [
              data.names,
              ...this.generateAns(data, header),
            ]}
          />
        </div>
      </div>
    );
  }
}

ReportIlp.contextType = KunjunganPasienContext;

export default withContext(KunjunganPasienContext, {
  dataKunjungan: "",
  onLoad: false,
})(ReportIlp);
